<template>
  <div class="players-region-modal" id="container-more-players" ref="container-more-players" >

    <div class="close-nav justify-content-center row mb-3" @click="hidePlayers()" v-if="player">
      <div class="col-md-7 col-sm-9 col-10 text-left">
        <h3 class="region_title">{{ $t('playerProfile.more_region_bottom') }} {{ translateRegion(player.region_id) }}</h3>
      </div>
      <div class="col-md-1 col-sm-3 col-2">
        <span class="close-icon">
          <IconClose :height="48" :width="48" />
        </span>
      </div>
    </div>

    <div class="players-region-modal__container" v-if="player">
      <div class="row justify-content-center">
        <div class="p-3 col-6 mb-5" v-for="p in players" :key="p.id">
          <BRow class="justify-content-center">
            <BCol cols="12" md="5">

              <div v-if="p.linked_list && p.linked_list.length > 1"  class="multi-faces">
                <RouterLink v-for="(r, ix) in p.linked_list" :key="r.id" :to="{ name: 'player.profile', params: { id: p.url } }">
                  <img :src="getPlayerImage(r.id)" :alt="r.name" width="100%" :class="`multi-img-side image-${ix}`" />
                </RouterLink>

                <RouterLink v-if="p.linked_list && p.linked_list.length > 1" :to="{ name: 'player.profile', params: { id: p.url } }">
                  <img :src="getPlayerImage(p.id)" alt="Profile image" :class="`multi-img-side image-big`">
                </RouterLink>
              </div>

              <RouterLink v-if="!p.linked_list" :to="{ name: 'player.profile', params: { id: p.url } }">
                <img :src="getPlayerImage(p.id)" :alt="p.short_name" class="border-round card-img-side">
              </RouterLink>
              <RouterLink v-if="p.linked_list && p.linked_list.length == 1" :to="{ name: 'player.profile', params: { id: p.url } }">
                <img :src="getPlayerImage(p.id)" :alt="p.short_name" class="card-img-side">
                <img v-for="r in p.linked_list" :key="r.id" :src="getPlayerImage(r.id)" class="relative-image" />
              </RouterLink>

            </BCol>
            <BCol cols="12" md="7" class="align-self-center">
              <div class="info_player">
                <div class="country_player text-white ">{{ translateIsoCountry(p.country_iso_3) }}</div>
                <div class="title_player">
                  <RouterLink class="d-flex" :to="{ name: 'player.profile', params: { id: p.url } }">
                    {{ p.title }}
                  </RouterLink>
                </div>
                <div class="long_player">
                  <RouterLink :to="{ name: 'player.profile', params: { id: p.url } }">
                    {{ p.short_name }}
                  </RouterLink>
                </div>
              </div>
            </BCol>
          </BRow>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { kebabCase } from 'lodash'
  import utils from '@/mixins/utils'
  import IconClose from '@/components/IconClose'

  export default {
    name: "PlayersRegion",
    mixins: [utils],
    components: {
      IconClose
    },
    props: {
      player: [Object],
      players: [Array]
    },
    methods: {
      kebabCase,
      hidePlayers() {
        document.getElementById('container-more-players').classList.remove('open-nav')
        document.querySelector('body').classList.remove('open-nav')
      }
    }
  }

</script>

<style lang="scss">

  @import '@/variables.scss';


  .region_title {
    color: var(--app-color-light);
  }

  .players-region-modal {
    z-index: $zindex-modal;
    position: fixed;
    left: 0;
    height: 100vh;
    bottom: -100vh;
    width: 100vw;
    padding: 0 5px;
    background: #0a0a0afc;
    overflow-x: hidden;
    overflow-y: auto;
    border-radius: 5px 0 0 5px;
    transition: bottom .2s ease-in;

    &.open-nav {
      bottom: 0;
      background: #0a0a0afc;
    }

    &__container {
      max-width: 720px;
      margin: 0 auto;
      padding-top: 85px;
    }

    ul {
      margin: 0;
      padding: 10px;
      list-style: none;
    }

    li {
      padding: 10px 0;
      border-bottom: dashed 1px #333;
    }

    a {
      padding: 0;
      color: #fff;
    }

    .close-nav {
      position: sticky;
      top: 0;
      padding: 65px 0 0 0;
      max-width: 720px;
      margin: 0 auto;
      text-align: right;
      align-items: flex-end;
      text-align: right;
      cursor: pointer;
      z-index: 999;
      background: linear-gradient(180deg, #000000 50%, #0a0a0a00 100%);

      a {
        display: inline;
      }

      svg {
        fill: #fff;
      }
    }

    .title_player {
      font-size: 21px;
      font-weight: 900;
      line-height: 21px;
      margin-bottom: 10px;
      a {
        color: var(--app-color-white) !important;
      }
    }


    .country_player {
      color: var(--app-color-dark);
    }

    .long_player {
      display: inline-block;
      font-size: 17px;
      padding: 3px;
      color: var(--app-color-black);
      background-color: var(--app-color-coin);

      a {
        font-size: 16px;
        margin: 10px 0;
        border-radius: 5px;
        color: var(--app-color-black) !important;
      }
    }

    .linked-list {
      position: relative;
      top: 15px;
      left: -25%;
      max-width: 320px;
    }

    .relative-image {
      position: absolute;
      max-width: 55%;
      right: 0;
      bottom: -45px;
      background: var(--app-color-light);
      border-radius: 100%;
    }

    .card-img-side {
      width: 100%;
      min-width: 125px;
      max-width: 125px;
      height: 125px;
      margin-right: 10px;
      border-radius: 100%;
      background: var(--app-color-coin);
    }
  }

  .multi-player-two {
    width: 125px;
    position: relative;
    display: block;
    padding-right: 10% !important;
    padding-bottom: 10% !important;

    .card-img-main {
      width: 100%;
      border-radius: 100%;
      background: var(--app-color-coin);
    }

    .card-img-main {
      width: 100%;
    }

    .relative-image {
      width: 65%;
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: var(--app-color-black) !important;
    }
  }

  .multi-faces {
    min-height: 180px;

    img {
      width: 100%;
      border-radius: 100%;
      background: var(--app-color-coin);

      &.multi-img-side {
        position: absolute;
        max-width: 100px;

        &.image-0 {
          top: 0;
          left: 0;
        }

        &.image-1 {
          top: 0;
          right: 0;
        }

        &.image-2 {
          bottom: 0;
          left: 0;
        }

        &.image-big {
          bottom: 0;
          right: 0;
          width: 75px;
          background-color: var(--app-color-black) !important;
        }
      }

      &.relative-image {
        position: absolute;
        width: 62%;
        bottom: -35px;
        right: 0;
        background: var(--app-color-black);
      }
    }
  }

</style>
